import moment from "moment";
import { AppConfigurationHelper } from "../../services/AppConfigurationHelper";

export enum DateTimeFormats {
  DateFormat = "DD/MM/YYYY",
  TimeFormat = "HH:mm",
  DateTimeFormat = "DD/MM/YYYY, HH:mm:ss",
  DateTimeFormatWithoutSeconds = "DD/MM/YYYY, HH:mm",
}
export class DateFormatter {
  static formatDateForCharts = (dateString: string) => {
    return moment.utc(dateString).local().format("DD-MM-YY HH:mm");
  };

  static formatDatewithHours = (dateString: string) => {
    return moment.utc(dateString).local().format("DD/MM/YYYY, hh:mm A");
  };

  // 24hrs date and time
  static formatTimeWithoutMeridiem = (dateString: string) => {
    return moment.utc(dateString).local().format("DD/MM/YYYY, HH:mm");
  };

  static formatDatewithHoursMonthName = (dateString: string) => {
    return moment
      .utc(dateString)
      .local()
      .format("DD MMM YYYY, hh:mm A")
      .toUpperCase();
  };

  static formatDate = (dateString: string | Date) => {
    return moment.utc(dateString).local().format(DateTimeFormats.DateFormat);
  };

  static formatDateToISO = (dateString: string | Date) => {
    return moment.utc(dateString, DateTimeFormats.DateFormat).toISOString();
  };

  static formatTime = (dateString: string | Date, isTime = false) => {
    return isTime
      ? moment
          .utc(dateString, "HH:mm:ss")
          .local()
          .format(DateTimeFormats.TimeFormat)
      : moment.utc(dateString).local().format(DateTimeFormats.TimeFormat);
  };

  static formatUTCTime = (dateString: string | Date) => {
    return moment(dateString, "HH:mm").utc().format("HH:mm:ss");
  };

  static formatLocalToUtcDateTime = (
    input: string | Date,
    outputFormat: DateTimeFormats
  ) => {
    return moment.utc(input).local().format(outputFormat);
  };

  static getCurrentAge = (date: string) => {
    const selectDate = moment.utc(date, "DD/MM/YYYY").local();
    return moment.duration(moment().diff(selectDate)).years(); //moment() is current date
  };

  static isFutureDateSelect = (date: string) => {
    return !moment(date, DateTimeFormats.DateFormat).isBefore(
      moment(new Date(), DateTimeFormats.DateFormat)
    );
  };

  static calculateAge = (dob: string): number => {
    const birthDate = new Date(dob); // Use the ISO 8601 date string to create a Date object
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth();
    const birthMonth = birthDate.getMonth();

    if (
      month < birthMonth ||
      (month === birthMonth && today.getDate() < birthDate.getDate())
    ) {
      age--; // Decrease age by 1 if the birthday hasn't occurred yet this year
    }

    return age;
  };

  static scheduleTime = (schedule: string): boolean => {
    let currentTime = moment();
    let endTime = moment(schedule, "HH:mm:ss");
    let beforeTime = endTime
      .clone()
      .subtract(
        AppConfigurationHelper.Instance().medicineIntervalAllowed,
        "minutes"
      );
    let afterTime = endTime
      .clone()
      .add(
        AppConfigurationHelper.Instance().medicineIntervalAllowed,
        "minutes"
      );
    return currentTime.isBetween(beforeTime, afterTime, undefined, "[]");
  };
}
